import { useAuth } from '../lib/auth-context';

// Placeholder chat view for Phase 1. Phase 2 wires conversation list + new-chat flow,
// Phase 3 adds the LiveKit voice loop.
export default function Chat() {
  const { user, signOut } = useAuth();

  return (
    <div className="flex h-full flex-col">
      <header className="flex items-center justify-between border-b border-slate-800 px-6 py-4">
        <div>
          <h1 className="text-base font-semibold text-slate-100">Frontier Overwatch</h1>
          <p className="text-xs text-slate-500">{user?.email}</p>
        </div>
        <button
          type="button"
          onClick={signOut}
          className="rounded-md border border-slate-700 px-3 py-1.5 text-sm text-slate-300 transition-colors hover:bg-slate-800 hover:text-slate-100"
        >
          Sign out
        </button>
      </header>

      <main className="flex flex-1 items-center justify-center px-6">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 rounded-full border border-emerald-400/40 bg-emerald-400/5" />
          <p className="mt-6 text-sm text-slate-400">
            Chat is wired up in Phase 2 + 3.
          </p>
        </div>
      </main>
    </div>
  );
}
